import { render, staticRenderFns } from "./messageDetails.vue?vue&type=template&id=c7121ba2&scoped=true&"
import script from "./messageDetails.vue?vue&type=script&lang=js&"
export * from "./messageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7121ba2",
  null
  
)

export default component.exports